import { Location } from '@angular/common';
import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { filter, map, mergeMap, take } from 'rxjs/operators';

import { PolicyAnalytics } from '@amfam/policy/models';
import { AnalyticsFacade } from '@amfam/shared/analytics';
import { Agent, agentQuery } from '@amfam/shared/utility/agent';
import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access';
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import { CopyService } from '@amfam/shared/utility/shared-services';
import { ConfirmationModel, DockingBarService, PageTitleService } from '@amfam/ui-kit';

import * as fromRoot from '../../../core/store';
import * as fromPolicyRoot from '../../+state';
import { ChangeRequest } from '../../models';

@Component({
  selector: 'app-change-request-confirmation',
  templateUrl: './change-request-confirmation.component.html',
  styleUrls: ['./change-request-confirmation.component.scss'],
  standalone: false
})
export class ChangeRequestConfirmationComponent implements OnInit, AfterViewInit {
  @ViewChild('policyCellTpl') policyCellTpl: TemplateRef<any>;
  @ViewChild('headerCellTpl') headerCellTpl: TemplateRef<any>;

  public confirmationData: Observable<ConfirmationModel>;

  confirmation = this.copyService.getCopy('policy.addressChange.confirmation');
  agents$: Observable<Agent[]> = this.store.select(agentQuery.getRealAgents).pipe(
    map(agents => {
      const state = this.location.getState() as { agentId: string };
      if (state?.agentId) {
        return agents.filter(agent => String(agent.agentId) === String(state.agentId));
      }
      return agents;
    })
  );
  newTemplate = this.featureflag.isEnabled('request_change_new_template');
  constructor(
    private dockingService: DockingBarService,
    private pageTitle: PageTitleService,
    private copyService: CopyService,
    private store: Store<fromRoot.RootState>,
    private analyticsFacade: AnalyticsFacade,
    private location: Location,
    private featureflag: FeatureFlagService
  ) {}

  ngOnInit() {
    // Fetch the copy
    const pageTitle: string = this.copyService.getCopy('policy.policyChangeTitle');

    // Set the page title and docking bar
    this.pageTitle.set(pageTitle);
    this.dockingService.registerHeading(pageTitle);

    this.confirmationData = this.store.pipe(
      select(fromPolicyRoot.getSelectedPolicyChange),
      filter(policyChangeState => !!policyChangeState.policyList),
      take(1),
      mergeMap(policyChangeState => this.formatConfirmationData(policyChangeState))
    );
  }

  /**
   * @description: Call the analytics after the page has been initialized and ready to view/interact.
   * This prevents the page from being blocked by the non essential analytics call.
   */
  ngAfterViewInit() {
    // Send the analytics
    this.analyticsFacade.trackPage(PolicyAnalytics.pagePoliciesRequestAChangeComplete);
  }

  private formatConfirmationData(
    policyChangeState: ChangeRequest
  ): Observable<{ confirmation: any }> {
    return of({
      confirmation: {
        heading: this.copyService.getCopy('policy.policyChangeSuccess')
      }
    });
  }

  public done() {
    this.analyticsFacade.trackButtonClick(PolicyAnalytics.buttonPoliciesTPIChangesDone);
    this.store.dispatch(
      fromRouterActions.Go({
        path: ['/overview']
      })
    );
  }

  requestAnotherChange() {
    this.store.dispatch(
      fromRouterActions.Go({
        path: ['/policies/changerequest']
      })
    );
  }
}
